"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const authForm_1 = __importDefault(require("../../loginform/authForm"));
const banner_1 = require("../banner");
const styledMessage_1 = require("../styledMessage");
const title_1 = require("../title");
const MessagePage = () => {
    const theme = (0, material_1.useTheme)();
    const { state } = (0, react_router_1.useLocation)();
    const { heading = '', message = '', subMessage = '', supportEmail = '' } = state || {};
    const navigate = (0, react_router_1.useNavigate)();
    if (!heading || !message) {
        void navigate('/signin/login');
    }
    return ((0, jsx_runtime_1.jsx)(authForm_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Container, { "data-testid": "messageContainer", style: {
                width: '360px',
                padding: 0,
                border: `1px solid ${theme.palette.tsGoColor.grayLightest}`,
                backgroundColor: theme.palette.tsGoColor.white,
                marginTop: '140px',
            }, children: [(0, jsx_runtime_1.jsx)(banner_1.Banner, { className: "banner signin" }), (0, jsx_runtime_1.jsx)(title_1.Title, { "data-testid": "messageContainer-title", children: heading }), (0, jsx_runtime_1.jsxs)(styledMessage_1.StyledMessage, { style: { maxWidth: '100%', boxSizing: 'border-box' }, "data-testid": "messageContainer-message", children: [message, subMessage && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), subMessage] })), supportEmail && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(material_1.Link, { href: `mailto:${supportEmail}`, sx: { color: theme.palette.primary.main }, children: supportEmail })] }))] })] }) }));
};
exports.default = MessagePage;
